import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import SmallDisplayInput from "../../../../../../components/DisplayInput/SmallDisplayInput";

const ColorCodedInput = ({
  name,
  labelText,
  width,
  control,
  attendanceMapping,
}) => {
  const value = useWatch({ name, control });

  const backgroundColor = useMemo(() => {
    const expected = attendanceMapping?.[name];
    const number = Number(value);
    if (
      value === null ||
      value === undefined ||
      isNaN(number) ||
      expected === undefined
    ) {
      return "#ffffff";
    }
    return number >= expected ? "#E8FEE8" : "#FEE8E8";
  }, [value, name, attendanceMapping]);

  return (
    <SmallDisplayInput
      name={name}
      labelText={labelText}
      value={value}
      width={width}
      backgroundColor={backgroundColor}
    />
  );
};

export default ColorCodedInput;
